<app-main-nav [@smoothCollapse]></app-main-nav>

<section class="section">
  <div class="container">
    <img class="image"
         [ngSrc]="'/assets/images/empty-box.png'"
         width="316"
         height="255"
         priority="true"
         alt="Empty box illustration"
    >

    <div class="title">404</div>

    <h1 class="h1">{{'NOT_FOUND.OOPS' | translate}}</h1>

    <h3 class="h3">{{'NOT_FOUND.404' | translate}}</h3>
  </div>
</section>
